export default __webpack_public_path__ + "static/media/video1.b965e4c4.jpg";